// Centralized i18n strings + candidate translations for the Kerala CM Poll.

export const STRINGS = {
  en: {
    lang_toggle_label: "Language",
    en_label: "EN",
    ml_label: "ML",

    // ===== Kerala Speaks (global) =====
    brand_super_eyebrow: "KERALA · 2026",
    brand_super_name: "KERALA SPEAKS",
    nav_home: "Home",
    nav_about: "About",
    nav_previous_polls: "Previous Polls",

    // Home page
    home_eyebrow: "KERALA SPEAKS",
    home_title_1: "THE FIRST",
    home_title_2: "100 DAYS.",
    home_sub: "Half a million citizens participated in choosing Kerala's next leader. Now Kerala speaks about what comes next. What should be the top priority for the new Chief Minister?",

    // Stats bar
    stats_messages: "Messages",
    stats_upvotes: "Upvotes",
    stats_top_category: "Most discussed",

    // Submit form
    submit_eyebrow: "★ YOUR VOICE ★",
    submit_prompt: "If you could tell the new Chief Minister one thing, what would it be?",
    civility_notice: "Keep the conversation respectful and constructive. Messages containing abuse, hate speech, personal attacks, or foul language may be removed.",
    submit_message_label: "Your message",
    submit_placeholder: "What's the one thing you want the new CM to act on in the first 100 days?",
    submit_category_label: "Topic",
    submit_category_placeholder: "Choose a topic…",
    submit_category_required: "Please choose a topic before posting.",
    submit_button: "POST MESSAGE",
    submit_submitting: "POSTING…",
    submit_success: "Your message is live. Thank you for speaking up.",
    submit_too_short: "Please type a bit more (at least 10 characters)",
    submit_error_generic: "Could not post your message. Please try again.",

    // Step 2 — required demographics + optional opt-in
    step2_eyebrow: "★ STEP 2 ★",
    step2_heading: "Help us understand Kerala better.",
    step2_sub: "We're tracking patterns, not identity. Skip anytime.",
    step2_required_note: "Age group, district, and occupation help us see who's speaking up. Gender and email stay optional.",
    step2_age_label: "Age group",
    step2_district_label: "District",
    step2_occupation_label: "Student / Working / Business / Other",
    step2_gender_label: "Gender (optional)",
    step2_email_label: "Email (optional)",
    step2_email_placeholder: "your@email.com",
    step2_save_btn: "SAVE INSIGHTS",
    step2_saving_btn: "SAVING…",
    step2_skip_btn: "SKIP",
    step2_post_another_btn: "POST ANOTHER",
    step2_done: "Thanks. You're helping make Kerala's data better.",
    step2_required_error: "Please fill age group, district, and occupation — or click Skip if you'd rather not.",
    required_mark: "*",

    // Thank-you / share screen
    thanks_eyebrow: "★ THANK YOU, KERALA ★",
    thanks_heading: "Thank you, Kerala.",
    thanks_sub: "Your voice is now part of Kerala's public conversation.",
    invite_heading: "Invite others to participate.",
    invite_sub: "Friends who click your link land directly on your message — ready to upvote.",
    share_your_message_btn: "Share your message",
    copy_direct_link_btn: "Copy direct link",
    instagram_story_btn: "Instagram Story",
    see_feed_heading: "Want to see what others are saying?",
    see_feed_btn: "BACK TO THE FEED",
    invite_share_text: (preview) =>
      `I just shared an idea on Kerala Speaks. Read it, upvote it, or post your own —`,

    notify_heading: "Want to participate faster next time?",
    notify_save_label: "Save my profile for next time",
    notify_subscribe_label: "Notify me about future civic questions",
    notify_promise: "No spam. No political messaging. Only major civic participation updates.",

    placeholder_select: "—",
    age_under_18: "Under 18",
    age_18_24: "18 – 24",
    age_25_34: "25 – 34",
    age_35_44: "35 – 44",
    age_45_54: "45 – 54",
    age_55_64: "55 – 64",
    age_65_plus: "65+",
    occupation_student: "Student",
    occupation_working: "Working",
    occupation_business: "Business",
    occupation_homemaker: "Homemaker",
    occupation_retired: "Retired",
    occupation_other: "Other",
    gender_female: "Female",
    gender_male: "Male",
    gender_non_binary: "Non-binary",
    gender_prefer_not: "Prefer not to say",
    district_alappuzha: "Alappuzha",
    district_ernakulam: "Ernakulam",
    district_idukki: "Idukki",
    district_kannur: "Kannur",
    district_kasaragod: "Kasaragod",
    district_kollam: "Kollam",
    district_kottayam: "Kottayam",
    district_kozhikode: "Kozhikode",
    district_malappuram: "Malappuram",
    district_palakkad: "Palakkad",
    district_pathanamthitta: "Pathanamthitta",
    district_thiruvananthapuram: "Thiruvananthapuram",
    district_thrissur: "Thrissur",
    district_wayanad: "Wayanad",
    district_outside_kerala: "Outside Kerala",

    // Feed
    feed_eyebrow: "★ PUBLIC MESSAGES ★",
    feed_heading: "What Kerala is saying",
    feed_messages_word: "messages",
    feed_empty: "Be the first to speak up.",
    feed_loading: "Loading more…",
    feed_end: "★ You've reached the end ★",
    sort_aria: "Sort messages",
    sort_trending: "Trending",
    sort_upvotes: "Most Upvoted",
    sort_latest: "Latest",
    category_all: "All",
    featured_tag: "Featured",
    upvote_aria_label: "Upvote this message",
    read_more: "Read more →",
    read_less: "← Read less",

    // Share
    share_eyebrow: "★ SPREAD THE WORD ★",
    share_heading: "Share Kerala's priorities with others.",
    share_sub: "The more voices, the clearer the message.",
    share_line_text: "I just shared an idea on Kerala Speaks. Read it, upvote it, or post your own —",

    // Previous poll CTA on home
    previous_poll_cta_eyebrow: "FROM THE ARCHIVE",
    previous_poll_cta_title: "See the poll that started it all.",
    previous_poll_cta_sub: "Half a million citizens. Three contenders. One Chief Minister.",
    previous_poll_cta_button: "View Kerala CM 2026",

    // About page
    about_eyebrow: "ABOUT",
    about_title: "Kerala Speaks.",
    about_p1: "Kerala Speaks is an independent, non-partisan civic platform where citizens of Kerala share short, public messages about the things that matter most to them.",
    about_p2: "It is the spiritual successor to thenextcm.com — the citizens' poll that gathered more than half a million voices to choose Kerala's next Chief Minister. Now that the verdict is in, the conversation shifts: what should happen in the first 100 days, and the years that follow.",
    about_p3: "We are not affiliated with any political party. We have no donors, no political backers, and no editorial line beyond \"civic, civil, and clear\". Anyone with an internet connection can post. Every published message has been reviewed for abuse, slurs, and personal attacks.",
    about_p4: "Our north star is simple: make it easy for ordinary people to be heard, and for leaders to hear them.",
    about_civility_label: "OUR RULES",
    about_civility_body: "Keep it respectful. Keep it constructive. Disagreement is welcome — abuse, hate speech, slurs, and personal attacks are not. Messages that violate these standards will be removed, and repeat violations may be blocked.",
    about_contact_label: "GET IN TOUCH",
    about_contact_body: "Press, partnerships, civic-tech collaboration, or feedback —",
    about_contact_email: "keralaspeaks7@gmail.com",

    // Previous Polls page
    prev_polls_eyebrow: "THE ARCHIVE",
    prev_polls_title: "Previous Polls.",
    prev_polls_sub: "Completed civic moments. Each one is preserved exactly as it was on the day it closed.",
    archive_card_label: "★ KERALA · 2026 ★",
    archive_card_title: "The Kerala CM 2026 Poll",
    archive_card_sub: "The citizens' straw poll for Kerala's next Chief Minister. Now closed.",
    archive_card_announced_on: "Announced",
    archive_view_btn: "Open archive",
    archive_coming_soon_label: "COMING SOON",
    archive_coming_soon_title: "More archives ahead",
    archive_coming_soon_sub: "Every Kerala Speaks campaign will live here once it closes.",

    // ===== Message detail (deep link) =====
    detail_back: "← Back to Kerala Speaks",
    detail_eyebrow: "A FRIEND SHARED THIS",
    detail_title: "Someone you know wants to be heard.",
    detail_sub: "This is a single citizen's message to the new Chief Minister, posted on Kerala Speaks. Upvote it if you agree — or post your own message to the feed.",
    detail_related_heading: "MORE ON",
    detail_cta_eyebrow: "JOIN THE CONVERSATION",
    detail_cta_title: "Got something to say to the new CM?",
    detail_cta_sub: "Add your message to the public feed. Half a million Keralites already spoke up — your voice matters too.",
    detail_cta_button: "GO TO KERALA SPEAKS",
    detail_not_found_heading: "Message not found",
    detail_not_found_body: "This message may have been removed by a moderator, or the link is incorrect.",
    detail_go_home: "Back to Kerala Speaks",

    brand_eyebrow: "KERALA · 2026",
    brand_name: "THE PEOPLE'S POLL",
    one_vote_browser: "ONE VOTE / BROWSER",

    hero_eyebrow: "★ WHO SHOULD LEAD KERALA NEXT? ★",
    hero_title_1: "KERALA",
    hero_title_2: "DECIDES.",
    hero_sub_vote:
      "A citizens' voice poll for the next Chief Minister of Kerala. Pick one of the three contenders below. Your vote is anonymous — results unlock the moment you cast.",
    hero_sub_results:
      "A citizens' voice poll for the next Chief Minister of Kerala. Results below are live and update as more citizens vote.",

    ballot_heading: "★ THE BALLOT ★",
    ballot_help: "Choose 1 of 3 · Final",
    candidate_label: "CANDIDATE",
    party: "INDIAN NATIONAL CONGRESS",
    cast_vote: "CAST VOTE",
    voting: "VOTING...",
    voted_stamp: "VOTED ✓",

    vote_counted: "YOUR VOTE IS COUNTED",
    live_results: "LIVE RESULTS",
    total_votes: "TOTAL VOTES",
    leading: "★ LEADING",
    your_vote: "YOUR VOTE",
    votes_word: "VOTES",
    poll_note: "★ UNOFFICIAL CITIZEN POLL ★ ONE VOTE PER BROWSER ★",
    footer_left: "★ KERALA SPEAKS · A CITIZEN-LED CIVIC PLATFORM ★",
    footer_right: "Built with respect for democracy",
    loading: "Loading the ballot...",

    spread_word: "SPREAD THE WORD",
    share_your_vote: "SHARE YOUR VOTE",
    share_help:
      "Download or share this poster. Every share gets another citizen to the ballot.",
    save: "SAVE",
    share: "SHARE",
    whatsapp: "WHATSAPP",
    post_x: "POST ON X",
    instagram: "INSTAGRAM",
    copy_link: "COPY LINK",
    copied: "COPIED",
    instagram_tip: "Image saved. Open Instagram → New Post or Story → pick this image from your gallery.",
    share_tag_leaders: "Tag leaders who should see what Kerala thinks.",

    // Top banner (homepage)
    stats_banner_text: "More than 500,000 votes registered. Add yours now.",
    stats_banner_cta: "VOTE NOW",
    stats_banner_cta_share: "SHARE YOUR VOTE",

    // Hero callouts
    hero_callout_million: "Half a million voices are already part of the conversation.",
    hero_callout_tag: "Tag leaders who should see what Kerala thinks.",

    card_i_voted: "I VOTED FOR",
    card_congrats_to: "CONGRATS TO",
    card_celebrate_subtitle: "KERALA'S  NEW  CHIEF  MINISTER",
    card_celebrate_invite: "★ See the people's verdict at thenextcm.com ★",
    card_for_cm: "FOR  CHIEF  MINISTER  OF  KERALA",
    card_invite: "★ Cast your vote too ★",
    card_kerala_decides: "KERALA DECIDES",

    card_anon_headline: "I VOTED.",
    card_anon_subtitle: "Three contenders.  One Chief Minister.  Cast yours.",

    reveal_section_label: "MY PICK ON THE POSTER",
    anon_label: "ANONYMOUS",
    reveal_label: "REVEAL",
    anon_help: "Anonymous: the poster shows all three candidates. Reveal: it shows who you picked.",

    format_section_label: "POSTER FORMAT",
    format_feed: "FEED",
    format_story: "STORY",
    format_help: "Feed: wide landscape (1200×630). Story: vertical 9:16 (1080×1920) for Instagram & WhatsApp stories.",

    share_text: (name) =>
      `I voted for ${name} for Kerala CM. Cast your vote at`,
    share_text_anon: () =>
      `I just voted in the Kerala CM poll. Cast your vote at`,

    error_server: "Could not reach the polling server. Please try again.",
    error_vote: "Vote could not be cast. Please try again.",

    // ===== Frozen / Final Results state =====
    frozen_banner_text: "The official Chief Minister has been announced. The poll is now closed.",
    frozen_banner_cta: "SEE FINAL RESULTS",
    hero_title_decided_1: "KERALA",
    hero_title_decided_2: "DECIDED.",
    hero_sub_frozen:
      "The official Chief Minister has been announced. The citizen poll is closed. Below: who Kerala chose vs. who was chosen.",
    announcement_eyebrow: "★ OFFICIAL ANNOUNCEMENT ★",
    announcement_label: "The next Chief Minister of Kerala",
    announced_on: "Announced on",
    days_live: "DAYS LIVE",
    voting_closed_overlay: "VOTING CLOSED",
    voting_closed_sub: "The official CM has been announced.",
    comparison_heading: "★ PUBLIC PULSE vs OFFICIAL DECISION ★",
    comparison_public_label: "What citizens said",
    comparison_official_label: "Who was chosen",
    final_results_label: "FINAL RESULTS",
    poll_locked_note: "★ POLL CLOSED · NUMBERS ARE FINAL ★",
    timeline_heading: "★ THE TIMELINE ★",
    timeline_launched: "Poll launched",
    timeline_announced: "CM announced",
    timeline_total_votes: "Total votes",
    civic_thanks_heading: "Thank you, Kerala.",
    civic_thanks_body:
      "Whether your candidate won or not, your voice mattered. Half a million citizens spoke up — that is what a healthy democracy looks like. Stay loud. Stay civic. See you at the next vote.",
    waitlist_heading: "★ WHAT'S NEXT ★",
    waitlist_sub: "Get notified when we open the next civic poll.",
    waitlist_placeholder: "your@email.com",
    waitlist_cta: "NOTIFY ME",
    waitlist_submitting: "SUBMITTING...",
    waitlist_success: "You're on the list. Thank you.",
    waitlist_error_invalid: "Please enter a valid email address.",
    waitlist_error_generic: "Could not save right now. Please try again.",

    // ===== Velocity sparkline =====
    sparkline_heading: "★ THE VELOCITY ★",
    sparkline_sub: "Votes cast per day across the life of the poll.",
    sparkline_peak_day: "Peak day",
    sparkline_first_day: "Day 1",
    sparkline_last_day: "Final day",
    sparkline_y_axis_label: "Votes per day",
    sparkline_empty: "Not enough days yet to draw the curve.",

    // ===== Congratulations (frozen state share) =====
    congrats_heading_for: (name) => `SEND CONGRATULATIONS TO ${name}`,
    congrats_help: "Kerala has chosen. Share a congratulatory poster — tag the new CM, tag the leaders, keep the conversation civic.",
    share_text_congrats: (cm) =>
      `Congratulations to ${cm} on becoming Kerala's next Chief Minister! See what half a million citizens said:`,

    // ===== Poll Detail page (multi-poll engine) =====
    poll_back: "← Kerala Speaks",
    poll_eyebrow_fallback: "Civic Poll",
    poll_cast_vote_title: "Cast your vote",
    poll_vote_submit: "Submit my vote →",
    poll_vote_submitting: "Submitting…",
    poll_vote_error_generic: "Could not record your vote.",
    poll_results_title: "Live results",
    poll_results_sub: (n) => `${n} votes · your vote was counted`,
    poll_result_your_vote: "· your vote",
    poll_profile_title: "Help us understand Kerala better",
    poll_profile_sub: "We track patterns, not identity. Skip anytime.",
    poll_profile_age: "Age group *",
    poll_profile_district: "District *",
    poll_profile_occupation: "Occupation *",
    poll_profile_gender: "Gender (optional)",
    poll_profile_email: "Email (optional — for future civic questions)",
    poll_profile_select: "Select…",
    poll_profile_prefer_not_say: "Prefer not to say",
    poll_profile_female: "Female",
    poll_profile_male: "Male",
    poll_profile_non_binary: "Non-binary / Other",
    poll_profile_save_me: "Save my profile for next time (on this browser only)",
    poll_profile_notify_me: "Notify me about future civic questions",
    poll_profile_submit: "Save profile →",
    poll_profile_skip: "Skip",
    poll_followup_placeholder: "Share your thoughts respectfully…",
    poll_followup_count: (n) => `${n} / 1200 · Goes through moderation before appearing publicly`,
    poll_followup_submit: "Share my response →",
    poll_followup_submitting: "Submitting…",
    poll_followup_min: "Please write at least a few words.",
    poll_followup_thanks_title: "Thank you.",
    poll_followup_thanks_body: "Your response has been received and will appear once reviewed by our moderators.",
    poll_share_title: "Invite others to speak up.",
    poll_share_sub: "The more voices participate, the clearer Kerala's priorities become.",
    poll_share_whatsapp: "Share on WhatsApp",
    poll_share_twitter: "Share on X",
    poll_share_copy: "Copy link",
    poll_share_copied: "Link copied ✓",
    poll_share_native: "Share via…",
    poll_share_image_eyebrow: "Auto-share image",
    poll_share_image_link: "Download branded image →",
    poll_share_text_mc: "I just shared my opinion on Kerala's stray dog issue at thenextcm.com. What do you think Kerala should do?",
    poll_share_text_open: "I just shared my voice on Kerala Speaks. Join the conversation:",
    poll_open_cta_title: "This is an open conversation.",
    poll_open_cta_sub: "Head to the homepage to share your message and upvote others.",
    poll_open_cta_btn: "Open Kerala Speaks home →",
    poll_loading: "Loading…",
    poll_voices_title: "What other citizens are saying",
    poll_voices_sub: (n) => `${n} approved voice${n === 1 ? "" : "s"} \u00b7 newest first`,
    poll_voices_featured: "\u2605 Featured by editors",
    poll_not_found: "Poll not found.",
    poll_back_home: "← Back to home",
    poll_load_error: "Could not load poll.",

    // Hero slider (multi-poll)
    hero_live_poll: "Live civic poll",
    hero_open_conv: "Open conversation",
    hero_cta_mc: "Cast your vote →",
    hero_cta_open: "Share your voice →",
  },

  ml: {
    lang_toggle_label: "ഭാഷ",
    en_label: "EN",
    ml_label: "ML",

    // ===== Kerala Speaks (global) =====
    brand_super_eyebrow: "കേരളം · 2026",
    brand_super_name: "കേരളം പറയുന്നു",
    nav_home: "ഹോം",
    nav_about: "എന്താണ്",
    nav_previous_polls: "മുൻ പോളുകൾ",

    home_eyebrow: "കേരളം പറയുന്നു",
    home_title_1: "ആദ്യ",
    home_title_2: "100 ദിവസങ്ങൾ.",
    home_sub: "കേരളത്തിന്റെ പുതിയ നേതാവിനെ തിരഞ്ഞെടുക്കാൻ അഞ്ച് ലക്ഷം പൗരന്മാർ പങ്കെടുത്തു. ഇപ്പോൾ കേരളം അടുത്തത് എന്താണെന്ന് പറയുന്നു. പുതിയ മുഖ്യമന്ത്രിയുടെ പ്രധാന മുൻഗണന എന്തായിരിക്കണം?",

    stats_messages: "സന്ദേശങ്ങൾ",
    stats_upvotes: "അപ്‌വോട്ടുകൾ",
    stats_top_category: "ഏറ്റവും ചർച്ച ചെയ്യപ്പെട്ടത്",

    submit_eyebrow: "★ നിങ്ങളുടെ ശബ്ദം ★",
    submit_prompt: "പുതിയ മുഖ്യമന്ത്രിയോട് നിങ്ങൾക്ക് ഒരു കാര്യം പറയാമെങ്കിൽ, അത് എന്തായിരിക്കും?",
    civility_notice: "സംഭാഷണം ആദരവുള്ളതും രചനാത്മകവുമായി നിലനിർത്തുക. ദുരുപയോഗം, വിദ്വേഷ പ്രസംഗം, വ്യക്തിപരമായ ആക്രമണം, അല്ലെങ്കിൽ അസഭ്യ ഭാഷ അടങ്ങിയ സന്ദേശങ്ങൾ നീക്കം ചെയ്യപ്പെടാം.",
    submit_message_label: "നിങ്ങളുടെ സന്ദേശം",
    submit_placeholder: "ആദ്യ 100 ദിവസത്തിനുള്ളിൽ പുതിയ മുഖ്യമന്ത്രി ചെയ്യണമെന്ന് നിങ്ങൾ ആഗ്രഹിക്കുന്ന ഒരു കാര്യം എന്താണ്?",
    submit_category_label: "വിഷയം",
    submit_category_placeholder: "ഒരു വിഷയം തിരഞ്ഞെടുക്കൂ…",
    submit_category_required: "പോസ്റ്റ് ചെയ്യും മുമ്പ് ഒരു വിഷയം തിരഞ്ഞെടുക്കുക.",
    submit_button: "സന്ദേശം പോസ്റ്റ് ചെയ്യൂ",
    submit_submitting: "പോസ്റ്റ് ചെയ്യുന്നു…",
    submit_success: "നിങ്ങളുടെ സന്ദേശം ലൈവ് ആണ്. ശബ്ദമുയർത്തിയതിന് നന്ദി.",
    submit_too_short: "ദയവായി കുറച്ച് കൂടി ടൈപ്പ് ചെയ്യൂ (കുറഞ്ഞത് 10 അക്ഷരങ്ങൾ)",
    submit_error_generic: "നിങ്ങളുടെ സന്ദേശം പോസ്റ്റ് ചെയ്യാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക.",

    // Step 2
    step2_eyebrow: "★ ഘട്ടം 2 ★",
    step2_heading: "കേരളത്തെ കൂടുതൽ നന്നായി മനസ്സിലാക്കാൻ സഹായിക്കൂ.",
    step2_sub: "ഞങ്ങൾ പാറ്റേണുകൾ നോക്കുന്നു, വ്യക്തിത്വം അല്ല. എപ്പോൾ വേണമെങ്കിലും ഒഴിവാക്കാം.",
    step2_required_note: "പ്രായം, ജില്ല, തൊഴിൽ — ആരാണ് സംസാരിക്കുന്നതെന്ന് കാണാൻ ഇത് സഹായിക്കും. ലിംഗവും ഇമെയിലും ഐച്ഛികം.",
    step2_age_label: "പ്രായം",
    step2_district_label: "ജില്ല",
    step2_occupation_label: "വിദ്യാർത്ഥി / ജോലി / വ്യാപാരം / മറ്റുള്ളവ",
    step2_gender_label: "ലിംഗം (ഐച്ഛികം)",
    step2_email_label: "ഇമെയിൽ (ഐച്ഛികം)",
    step2_email_placeholder: "your@email.com",
    step2_save_btn: "സേവ് ചെയ്യൂ",
    step2_saving_btn: "സേവ് ചെയ്യുന്നു…",
    step2_skip_btn: "ഒഴിവാക്കൂ",
    step2_post_another_btn: "മറ്റൊന്ന് പോസ്റ്റ് ചെയ്യൂ",
    step2_done: "നന്ദി. കേരളത്തിന്റെ ഡാറ്റ മികച്ചതാക്കാൻ നിങ്ങൾ സഹായിക്കുന്നു.",
    step2_required_error: "പ്രായം, ജില്ല, തൊഴിൽ പൂരിപ്പിക്കുക — അല്ലെങ്കിൽ ഒഴിവാക്കൂ ക്ലിക്ക് ചെയ്യൂ.",
    required_mark: "*",

    // Thank-you / share screen
    thanks_eyebrow: "★ നന്ദി, കേരളം ★",
    thanks_heading: "നന്ദി, കേരളം.",
    thanks_sub: "നിങ്ങളുടെ ശബ്ദം ഇപ്പോൾ കേരളത്തിന്റെ പൊതു സംഭാഷണത്തിന്റെ ഭാഗമാണ്.",
    invite_heading: "മറ്റുള്ളവരെയും ക്ഷണിക്കൂ.",
    invite_sub: "നിങ്ങളുടെ ലിങ്കിൽ ക്ലിക്ക് ചെയ്യുന്നവർ നേരിട്ട് നിങ്ങളുടെ സന്ദേശത്തിലേക്ക് — അപ്‌വോട്ട് ചെയ്യാൻ തയ്യാർ.",
    share_your_message_btn: "നിങ്ങളുടെ സന്ദേശം ഷെയർ ചെയ്യൂ",
    copy_direct_link_btn: "നേരിട്ടുള്ള ലിങ്ക് കോപ്പി ചെയ്യൂ",
    instagram_story_btn: "ഇൻസ്റ്റാഗ്രാം സ്റ്റോറി",
    see_feed_heading: "മറ്റുള്ളവർ പറയുന്നത് കാണാൻ ആഗ്രഹിക്കുന്നോ?",
    see_feed_btn: "ഫീഡിലേക്ക് മടങ്ങൂ",
    invite_share_text: (preview) =>
      `ഞാൻ കേരളം പറയുന്നു-വിൽ ഒരു ആശയം പങ്കിട്ടു. വായിക്കൂ, അപ്‌വോട്ട് ചെയ്യൂ, അല്ലെങ്കിൽ നിങ്ങളുടേത് പോസ്റ്റ് ചെയ്യൂ —`,

    notify_heading: "അടുത്ത തവണ വേഗത്തിൽ പങ്കെടുക്കാൻ ആഗ്രഹിക്കുന്നോ?",
    notify_save_label: "എന്റെ പ്രൊഫൈൽ അടുത്ത തവണത്തേക്ക് സേവ് ചെയ്യൂ",
    notify_subscribe_label: "ഭാവിയിലെ പൗര ചോദ്യങ്ങളെ കുറിച്ച് അറിയിക്കൂ",
    notify_promise: "സ്പാം ഇല്ല. രാഷ്ട്രീയ സന്ദേശങ്ങൾ ഇല്ല. പ്രധാന പൗര പങ്കാളിത്ത അപ്‌ഡേറ്റുകൾ മാത്രം.",

    placeholder_select: "—",
    age_under_18: "18-ന് താഴെ",
    age_18_24: "18 – 24",
    age_25_34: "25 – 34",
    age_35_44: "35 – 44",
    age_45_54: "45 – 54",
    age_55_64: "55 – 64",
    age_65_plus: "65+",
    occupation_student: "വിദ്യാർത്ഥി",
    occupation_working: "ജോലി",
    occupation_business: "വ്യാപാരം",
    occupation_homemaker: "ഗൃഹനാഥ",
    occupation_retired: "വിരമിച്ചയാൾ",
    occupation_other: "മറ്റുള്ളവ",
    gender_female: "സ്ത്രീ",
    gender_male: "പുരുഷൻ",
    gender_non_binary: "നോൺ-ബൈനറി",
    gender_prefer_not: "പറയാൻ ആഗ്രഹിക്കുന്നില്ല",
    district_alappuzha: "ആലപ്പുഴ",
    district_ernakulam: "എറണാകുളം",
    district_idukki: "ഇടുക്കി",
    district_kannur: "കണ്ണൂർ",
    district_kasaragod: "കാസർഗോഡ്",
    district_kollam: "കൊല്ലം",
    district_kottayam: "കോട്ടയം",
    district_kozhikode: "കോഴിക്കോട്",
    district_malappuram: "മലപ്പുറം",
    district_palakkad: "പാലക്കാട്",
    district_pathanamthitta: "പത്തനംതിട്ട",
    district_thiruvananthapuram: "തിരുവനന്തപുരം",
    district_thrissur: "തൃശ്ശൂർ",
    district_wayanad: "വയനാട്",
    district_outside_kerala: "കേരളത്തിന് പുറത്ത്",

    feed_eyebrow: "★ പൊതു സന്ദേശങ്ങൾ ★",
    feed_heading: "കേരളം പറയുന്നത്",
    feed_messages_word: "സന്ദേശങ്ങൾ",
    feed_empty: "ആദ്യം സംസാരിക്കാൻ നിങ്ങൾ ആകൂ.",
    feed_loading: "കൂടുതൽ ലോഡ് ചെയ്യുന്നു…",
    feed_end: "★ അവസാനം എത്തി ★",
    sort_aria: "സന്ദേശങ്ങൾ ക്രമീകരിക്കുക",
    sort_trending: "ട്രെൻഡിങ്",
    sort_upvotes: "കൂടുതൽ അപ്‌വോട്ടുകൾ",
    sort_latest: "പുതിയത്",
    category_all: "എല്ലാം",
    featured_tag: "പ്രത്യേകം",
    upvote_aria_label: "ഈ സന്ദേശം അപ്‌വോട്ട് ചെയ്യൂ",
    read_more: "കൂടുതൽ വായിക്കൂ →",
    read_less: "← കുറച്ച് കാണിക്കൂ",

    share_eyebrow: "★ പ്രചാരണം ★",
    share_heading: "കേരളത്തിന്റെ മുൻഗണനകൾ പങ്കിടൂ.",
    share_sub: "കൂടുതൽ ശബ്ദങ്ങൾ, വ്യക്തമായ സന്ദേശം.",
    share_line_text: "ഞാൻ കേരളം പറയുന്നു-വിൽ ഒരു ആശയം പങ്കിട്ടു. വായിക്കൂ, അപ്‌വോട്ട് ചെയ്യൂ, അല്ലെങ്കിൽ നിങ്ങളുടേത് പോസ്റ്റ് ചെയ്യൂ —",

    previous_poll_cta_eyebrow: "ആർക്കൈവിൽ നിന്ന്",
    previous_poll_cta_title: "എല്ലാം തുടങ്ങിയ പോൾ കാണൂ.",
    previous_poll_cta_sub: "അഞ്ച് ലക്ഷം പൗരന്മാർ. മൂന്ന് സ്ഥാനാർത്ഥികൾ. ഒരു മുഖ്യമന്ത്രി.",
    previous_poll_cta_button: "കേരളം മുഖ്യമന്ത്രി 2026 കാണൂ",

    about_eyebrow: "എന്താണ്",
    about_title: "കേരളം പറയുന്നു.",
    about_p1: "കേരളം പറയുന്നു — ഒരു സ്വതന്ത്ര, പക്ഷപാതരഹിത പൗര വേദിയാണ്. ഇവിടെ കേരളത്തിലെ പൗരന്മാർ തങ്ങൾക്ക് പ്രധാനപ്പെട്ടതെന്ന് കരുതുന്ന കാര്യങ്ങളെ കുറിച്ച് ഹ്രസ്വവും പൊതുവുമായ സന്ദേശങ്ങൾ പങ്കിടുന്നു.",
    about_p2: "ഇത് thenextcm.com-ന്റെ പിന്തുടർച്ചയാണ് — കേരളത്തിന്റെ പുതിയ മുഖ്യമന്ത്രിയെ തിരഞ്ഞെടുക്കാൻ അഞ്ച് ലക്ഷത്തിലധികം ശബ്ദങ്ങൾ ഒത്തുചേർന്ന പൗര വോട്ടെടുപ്പ്. വിധി വന്ന ശേഷം, സംഭാഷണം മാറുന്നു: ആദ്യ 100 ദിവസത്തിലും തുടർന്നുള്ള വർഷങ്ങളിലും എന്ത് സംഭവിക്കണം.",
    about_p3: "ഞങ്ങൾ ഒരു രാഷ്ട്രീയ പാർട്ടിയുമായും ബന്ധപ്പെട്ടിട്ടില്ല. സംഭാവനക്കാരോ രാഷ്ട്രീയ പിന്തുണക്കാരോ ഇല്ല. \"പൗരത, മാന്യത, വ്യക്തത\" — അതാണ് ഞങ്ങളുടെ നയം. ഇന്റർനെറ്റ് ഉള്ള ഏതൊരാൾക്കും പോസ്റ്റ് ചെയ്യാം. പ്രസിദ്ധീകരിച്ച ഓരോ സന്ദേശവും ദുരുപയോഗത്തിനും അസഭ്യത്തിനും വ്യക്തിപരമായ ആക്രമണത്തിനും വേണ്ടി പരിശോധിച്ചതാണ്.",
    about_p4: "ഞങ്ങളുടെ ലക്ഷ്യം ലളിതമാണ്: സാധാരണ ജനങ്ങൾക്ക് കേൾക്കാനും, നേതാക്കൾക്ക് അവരെ കേൾക്കാനും എളുപ്പമാക്കുക.",
    about_civility_label: "നിയമങ്ങൾ",
    about_civility_body: "ആദരവ് നിലനിർത്തുക. രചനാത്മകമായി ഇടപെടുക. വിയോജിപ്പ് സ്വാഗതം — ദുരുപയോഗം, വിദ്വേഷ പ്രസംഗം, അസഭ്യം, വ്യക്തിപരമായ ആക്രമണം എന്നിവ അല്ല. ഈ മാനദണ്ഡങ്ങൾ ലംഘിക്കുന്ന സന്ദേശങ്ങൾ നീക്കം ചെയ്യും, ആവർത്തിച്ചാൽ ബ്ലോക്ക് ചെയ്യാം.",
    about_contact_label: "ബന്ധപ്പെടുക",
    about_contact_body: "പ്രസ്സ്, പങ്കാളിത്തം, പൗര-സാങ്കേതിക സഹകരണം, അല്ലെങ്കിൽ ഫീഡ്‌ബാക്ക് —",
    about_contact_email: "keralaspeaks7@gmail.com",

    prev_polls_eyebrow: "ആർക്കൈവ്",
    prev_polls_title: "മുൻ പോളുകൾ.",
    prev_polls_sub: "പൂർത്തിയായ പൗര നിമിഷങ്ങൾ. ഓരോന്നും അവസാനിച്ച ദിവസത്തെ അവസ്ഥയിൽ കൃത്യമായി സംരക്ഷിച്ചിരിക്കുന്നു.",
    archive_card_label: "★ കേരളം · 2026 ★",
    archive_card_title: "കേരളം മുഖ്യമന്ത്രി 2026 പോൾ",
    archive_card_sub: "കേരളത്തിന്റെ പുതിയ മുഖ്യമന്ത്രിയ്ക്കായുള്ള പൗര വോട്ടെടുപ്പ്. ഇപ്പോൾ അവസാനിച്ചു.",
    archive_card_announced_on: "പ്രഖ്യാപിച്ചത്",
    archive_view_btn: "ആർക്കൈവ് കാണൂ",
    archive_coming_soon_label: "വരുന്നു",
    archive_coming_soon_title: "കൂടുതൽ ആർക്കൈവുകൾ",
    archive_coming_soon_sub: "ഓരോ കേരളം പറയുന്നു കാമ്പെയ്നും അവസാനിക്കുമ്പോൾ ഇവിടെ ജീവിക്കും.",

    // ===== Message detail =====
    detail_back: "← കേരളം പറയുന്നു-വിലേക്ക് മടങ്ങൂ",
    detail_eyebrow: "ഒരു സുഹൃത്ത് ഇത് ഷെയർ ചെയ്തു",
    detail_title: "നിങ്ങൾക്കറിയാവുന്ന ഒരാൾ കേൾക്കപ്പെടാൻ ആഗ്രഹിക്കുന്നു.",
    detail_sub: "കേരളം പറയുന്നു-വിൽ ഒരു പൗരൻ പുതിയ മുഖ്യമന്ത്രിയോട് പറഞ്ഞ ഒരൊറ്റ സന്ദേശമാണിത്. നിങ്ങൾ സമ്മതിക്കുന്നുവെങ്കിൽ അപ്‌വോട്ട് ചെയ്യൂ — അല്ലെങ്കിൽ നിങ്ങളുടെ സ്വന്തം സന്ദേശം ഫീഡിൽ പോസ്റ്റ് ചെയ്യൂ.",
    detail_related_heading: "ഇതേ വിഷയത്തിലുള്ളവ:",
    detail_cta_eyebrow: "സംഭാഷണത്തിൽ ചേരൂ",
    detail_cta_title: "പുതിയ മുഖ്യമന്ത്രിയോട് നിങ്ങൾക്ക് എന്തെങ്കിലും പറയാനുണ്ടോ?",
    detail_cta_sub: "നിങ്ങളുടെ സന്ദേശം പൊതു ഫീഡിൽ ചേർക്കൂ. അഞ്ച് ലക്ഷം മലയാളികൾ ഇതിനോടകം സംസാരിച്ചു — നിങ്ങളുടെ ശബ്ദത്തിനും വിലയുണ്ട്.",
    detail_cta_button: "കേരളം പറയുന്നു-വിലേക്ക് പോകൂ",
    detail_not_found_heading: "സന്ദേശം കണ്ടെത്താനായില്ല",
    detail_not_found_body: "ഈ സന്ദേശം മോഡറേറ്റർ നീക്കം ചെയ്തിരിക്കാം, അല്ലെങ്കിൽ ലിങ്ക് തെറ്റാണ്.",
    detail_go_home: "കേരളം പറയുന്നു-വിലേക്ക് മടങ്ങൂ",

    brand_eyebrow: "കേരളം · 2026",
    brand_name: "ജനവിധി",
    one_vote_browser: "ഒരു വോട്ട് / ബ്രൗസർ",

    hero_eyebrow: "★ കേരളത്തെ ആര് നയിക്കണം? ★",
    hero_title_1: "കേരളം",
    hero_title_2: "തീരുമാനിക്കും.",
    hero_sub_vote:
      "അടുത്ത മുഖ്യമന്ത്രിയെ തിരഞ്ഞെടുക്കാനുള്ള ജനവിധി. താഴെയുള്ള മൂന്ന് സ്ഥാനാർത്ഥികളിൽ ഒരാളെ തിരഞ്ഞെടുക്കുക. നിങ്ങളുടെ വോട്ട് അജ്ഞാതമാണ് — വോട്ട് ചെയ്ത ഉടനെ ഫലങ്ങൾ കാണാം.",
    hero_sub_results:
      "അടുത്ത മുഖ്യമന്ത്രിയെ തിരഞ്ഞെടുക്കാനുള്ള ജനവിധി. താഴെയുള്ള ഫലങ്ങൾ തത്സമയം പുതുക്കപ്പെടുന്നു.",

    ballot_heading: "★ ബാലറ്റ് ★",
    ballot_help: "3-ൽ 1 തിരഞ്ഞെടുക്കുക · അന്തിമം",
    candidate_label: "സ്ഥാനാർത്ഥി",
    party: "ഇന്ത്യൻ നാഷണൽ കോൺഗ്രസ്",
    cast_vote: "വോട്ട് ചെയ്യുക",
    voting: "വോട്ട് ചെയ്യുന്നു...",
    voted_stamp: "വോട്ട് ചെയ്തു ✓",

    vote_counted: "നിങ്ങളുടെ വോട്ട് രേഖപ്പെടുത്തി",
    live_results: "തത്സമയ ഫലങ്ങൾ",
    total_votes: "ആകെ വോട്ടുകൾ",
    leading: "★ മുന്നിൽ",
    your_vote: "നിങ്ങളുടെ വോട്ട്",
    votes_word: "വോട്ടുകൾ",
    poll_note: "★ അനൗദ്യോഗിക ജനവിധി ★ ഒരു വോട്ട് / ബ്രൗസർ ★",
    footer_left: "★ കേരള സ്പീക്സ് · പൗരന്മാർ നടത്തുന്ന സിവിക് പ്ലാറ്റ്ഫോം ★",
    footer_right: "ജനാധിപത്യത്തോട് ആദരവോടെ",
    loading: "ലോഡ് ചെയ്യുന്നു...",

    spread_word: "പ്രചാരണം",
    share_your_vote: "നിങ്ങളുടെ വോട്ട് ഷെയർ ചെയ്യൂ",
    share_help:
      "ഈ പോസ്റ്റർ ഡൗൺലോഡ് ചെയ്യൂ അല്ലെങ്കിൽ ഷെയർ ചെയ്യൂ. ഓരോ ഷെയറും ഒരു പുതിയ വോട്ടറെ ബാലറ്റിലെത്തിക്കും.",
    save: "സേവ്",
    share: "ഷെയർ",
    whatsapp: "വാട്സ്ആപ്പ്",
    post_x: "X-ൽ പോസ്റ്റ്",
    instagram: "ഇൻസ്റ്റാഗ്രാം",
    copy_link: "ലിങ്ക് കോപ്പി",
    copied: "കോപ്പിയായി",
    instagram_tip: "ഇമേജ് സേവ് ചെയ്തു. ഇൻസ്റ്റാഗ്രാം തുറന്ന് ന്യൂ പോസ്റ്റ് അല്ലെങ്കിൽ സ്റ്റോറി → ഈ ഇമേജ് തിരഞ്ഞെടുക്കുക.",
    share_tag_leaders: "കേരളം എന്താണ് ചിന്തിക്കുന്നതെന്ന് കാണേണ്ട നേതാക്കളെ ടാഗ് ചെയ്യൂ.",

    stats_banner_text: "5 ലക്ഷത്തിലധികം വോട്ടുകൾ രജിസ്റ്റർ ചെയ്തു. നിങ്ങളും ഇപ്പോൾ വോട്ട് ചെയ്യൂ.",
    stats_banner_cta: "ഇപ്പോൾ വോട്ട് ചെയ്യൂ",
    stats_banner_cta_share: "നിങ്ങളുടെ വോട്ട് ഷെയർ ചെയ്യൂ",

    hero_callout_million: "5 ലക്ഷം ശബ്ദങ്ങൾ ഇതിനകം ഈ സംഭാഷണത്തിന്റെ ഭാഗമാണ്.",
    hero_callout_tag: "കേരളം എന്താണ് ചിന്തിക്കുന്നതെന്ന് കാണേണ്ട നേതാക്കളെ ടാഗ് ചെയ്യൂ.",

    card_i_voted: "ഞാൻ വോട്ട് ചെയ്തു",
    card_congrats_to: "അഭിനന്ദനങ്ങൾ",
    card_celebrate_subtitle: "കേരളത്തിന്റെ  പുതിയ  മുഖ്യമന്ത്രി",
    card_celebrate_invite: "★ ജനവിധി കാണൂ — thenextcm.com ★",
    card_for_cm: "കേരള മുഖ്യമന്ത്രിയായി",
    card_invite: "★ നിങ്ങളും വോട്ട് ചെയ്യൂ ★",
    card_kerala_decides: "കേരളം തീരുമാനിക്കും",

    card_anon_headline: "ഞാൻ വോട്ട് ചെയ്തു.",
    card_anon_subtitle: "മൂന്ന് സ്ഥാനാർത്ഥികൾ.  ഒരു മുഖ്യമന്ത്രി.  നിങ്ങളും വോട്ട് ചെയ്യൂ.",

    reveal_section_label: "എന്റെ തിരഞ്ഞെടുപ്പ് പോസ്റ്ററിൽ",
    anon_label: "അജ്ഞാതം",
    reveal_label: "കാണിക്കുക",
    anon_help: "അജ്ഞാതം: പോസ്റ്ററിൽ മൂന്ന് സ്ഥാനാർത്ഥികളും കാണാം. കാണിക്കുക: നിങ്ങൾ തിരഞ്ഞെടുത്ത സ്ഥാനാർത്ഥിയെ കാണിക്കും.",

    format_section_label: "പോസ്റ്റർ ഫോർമാറ്റ്",
    format_feed: "ഫീഡ്",
    format_story: "സ്റ്റോറി",
    format_help: "ഫീഡ്: വൈഡ് ലാൻഡ്സ്കേപ്പ് (1200×630). സ്റ്റോറി: വെർട്ടിക്കൽ 9:16 (1080×1920) ഇൻസ്റ്റാഗ്രാം & വാട്സ്ആപ്പ് സ്റ്റോറീസിന്.",

    share_text: (name) =>
      `ഞാൻ കേരള മുഖ്യമന്ത്രിയായി ${name}-ന് വോട്ട് ചെയ്തു. നിങ്ങളും വോട്ട് ചെയ്യൂ:`,
    share_text_anon: () =>
      `ഞാൻ കേരള മുഖ്യമന്ത്രി ജനവിധിയിൽ വോട്ട് ചെയ്തു. നിങ്ങളും വോട്ട് ചെയ്യൂ:`,

    error_server: "സെർവറുമായി ബന്ധപ്പെടാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക.",
    error_vote: "വോട്ട് ചെയ്യാൻ കഴിഞ്ഞില്ല. വീണ്ടും ശ്രമിക്കുക.",

    // ===== Frozen / Final Results state =====
    frozen_banner_text: "പുതിയ മുഖ്യമന്ത്രി ഔദ്യോഗികമായി പ്രഖ്യാപിക്കപ്പെട്ടു. ജനവിധി ഇപ്പോൾ അവസാനിച്ചു.",
    frozen_banner_cta: "അന്തിമ ഫലം കാണൂ",
    hero_title_decided_1: "കേരളം",
    hero_title_decided_2: "തീരുമാനിച്ചു.",
    hero_sub_frozen:
      "പുതിയ മുഖ്യമന്ത്രി ഔദ്യോഗികമായി പ്രഖ്യാപിക്കപ്പെട്ടു. ജനവിധി അവസാനിച്ചു. കേരളം ആരെ തിരഞ്ഞെടുത്തു vs. ആരെ തിരഞ്ഞെടുത്തു — താഴെ കാണാം.",
    announcement_eyebrow: "★ ഔദ്യോഗിക പ്രഖ്യാപനം ★",
    announcement_label: "കേരളത്തിന്റെ പുതിയ മുഖ്യമന്ത്രി",
    announced_on: "പ്രഖ്യാപിച്ച തീയതി",
    days_live: "ദിവസങ്ങൾ",
    voting_closed_overlay: "വോട്ടെടുപ്പ് അവസാനിച്ചു",
    voting_closed_sub: "ഔദ്യോഗിക മുഖ്യമന്ത്രി പ്രഖ്യാപിക്കപ്പെട്ടു.",
    comparison_heading: "★ ജനവിധി vs ഔദ്യോഗിക തീരുമാനം ★",
    comparison_public_label: "ജനങ്ങൾ പറഞ്ഞത്",
    comparison_official_label: "തിരഞ്ഞെടുക്കപ്പെട്ടത്",
    final_results_label: "അന്തിമ ഫലം",
    poll_locked_note: "★ വോട്ടെടുപ്പ് അവസാനിച്ചു · കണക്കുകൾ അന്തിമം ★",
    timeline_heading: "★ ടൈംലൈൻ ★",
    timeline_launched: "ജനവിധി തുടങ്ങിയത്",
    timeline_announced: "മുഖ്യമന്ത്രി പ്രഖ്യാപനം",
    timeline_total_votes: "ആകെ വോട്ടുകൾ",
    civic_thanks_heading: "നന്ദി, കേരളം.",
    civic_thanks_body:
      "നിങ്ങളുടെ സ്ഥാനാർത്ഥി ജയിച്ചാലും ഇല്ലെങ്കിലും, നിങ്ങളുടെ ശബ്ദത്തിന് വിലയുണ്ടായിരുന്നു. അഞ്ച് ലക്ഷം പൗരന്മാർ സംസാരിച്ചു — അതാണ് ആരോഗ്യകരമായ ജനാധിപത്യം. ശബ്ദമുയർത്തിക്കൊണ്ടേയിരിക്കൂ. അടുത്ത വോട്ടെടുപ്പിൽ കാണാം.",
    waitlist_heading: "★ അടുത്തത് എന്ത് ★",
    waitlist_sub: "ഞങ്ങളുടെ അടുത്ത ജനവിധി തുടങ്ങുമ്പോൾ അറിയിക്കാം.",
    waitlist_placeholder: "your@email.com",
    waitlist_cta: "എനിക്ക് അറിയിക്കൂ",
    waitlist_submitting: "സമർപ്പിക്കുന്നു...",
    waitlist_success: "നിങ്ങൾ ലിസ്റ്റിലുണ്ട്. നന്ദി.",
    waitlist_error_invalid: "സാധുവായ ഇമെയിൽ വിലാസം നൽകുക.",
    waitlist_error_generic: "ഇപ്പോൾ സേവ് ചെയ്യാൻ കഴിയുന്നില്ല. വീണ്ടും ശ്രമിക്കുക.",

    // ===== Velocity sparkline =====
    sparkline_heading: "★ വേഗത ★",
    sparkline_sub: "ജനവിധിയുടെ ഓരോ ദിവസത്തെയും വോട്ടുകൾ.",
    sparkline_peak_day: "ഉയർന്ന ദിവസം",
    sparkline_first_day: "ആദ്യ ദിവസം",
    sparkline_last_day: "അവസാന ദിവസം",
    sparkline_y_axis_label: "ദിവസത്തിന് വോട്ടുകൾ",
    sparkline_empty: "വക്രം വരയ്ക്കാൻ ആവശ്യമായ ദിവസങ്ങൾ ഇതുവരെ ലഭ്യമല്ല.",

    // ===== Congratulations (frozen state share) =====
    congrats_heading_for: (name) => `${name}-ന് അഭിനന്ദനങ്ങൾ അയക്കൂ`,
    congrats_help: "കേരളം തീരുമാനിച്ചു. ഒരു അഭിനന്ദന പോസ്റ്റർ ഷെയർ ചെയ്യൂ — പുതിയ മുഖ്യമന്ത്രിയെ, നേതാക്കളെ ടാഗ് ചെയ്യൂ.",
    share_text_congrats: (cm) =>
      `കേരളത്തിന്റെ പുതിയ മുഖ്യമന്ത്രി ${cm}-ന് അഭിനന്ദനങ്ങൾ! അഞ്ച് ലക്ഷം പൗരന്മാർ പറഞ്ഞത് കാണൂ:`,

    // ===== Poll Detail page (multi-poll engine) =====
    poll_back: "← കേരളം സംസാരിക്കുന്നു",
    poll_eyebrow_fallback: "പൗര വോട്ടെടുപ്പ്",
    poll_cast_vote_title: "നിങ്ങളുടെ വോട്ട് രേഖപ്പെടുത്തൂ",
    poll_vote_submit: "എന്റെ വോട്ട് സമർപ്പിക്കൂ →",
    poll_vote_submitting: "സമർപ്പിക്കുന്നു…",
    poll_vote_error_generic: "നിങ്ങളുടെ വോട്ട് രേഖപ്പെടുത്താൻ കഴിഞ്ഞില്ല.",
    poll_results_title: "തത്സമയ ഫലങ്ങൾ",
    poll_results_sub: (n) => `${n} വോട്ടുകൾ · നിങ്ങളുടെ വോട്ട് രേഖപ്പെടുത്തി`,
    poll_result_your_vote: "· നിങ്ങളുടെ വോട്ട്",
    poll_profile_title: "കേരളത്തെ നന്നായി മനസ്സിലാക്കാൻ ഞങ്ങളെ സഹായിക്കൂ",
    poll_profile_sub: "ഞങ്ങൾ പാറ്റേണുകൾ പഠിക്കുന്നു, വ്യക്തിത്വമല്ല. എപ്പോൾ വേണമെങ്കിലും ഒഴിവാക്കാം.",
    poll_profile_age: "പ്രായ വിഭാഗം *",
    poll_profile_district: "ജില്ല *",
    poll_profile_occupation: "തൊഴിൽ *",
    poll_profile_gender: "ലിംഗം (ഐച്ഛികം)",
    poll_profile_email: "ഇമെയിൽ (ഐച്ഛികം — ഭാവി ചോദ്യങ്ങൾക്ക്)",
    poll_profile_select: "തിരഞ്ഞെടുക്കുക…",
    poll_profile_prefer_not_say: "പറയാൻ ആഗ്രഹിക്കുന്നില്ല",
    poll_profile_female: "സ്ത്രീ",
    poll_profile_male: "പുരുഷൻ",
    poll_profile_non_binary: "നോൺ-ബൈനറി / മറ്റ്",
    poll_profile_save_me: "അടുത്ത തവണത്തേക്ക് എന്റെ പ്രൊഫൈൽ സേവ് ചെയ്യൂ (ഈ ബ്രൗസറിൽ മാത്രം)",
    poll_profile_notify_me: "ഭാവി പൗര ചോദ്യങ്ങളെ കുറിച്ച് എനിക്ക് അറിയിക്കൂ",
    poll_profile_submit: "പ്രൊഫൈൽ സേവ് ചെയ്യൂ →",
    poll_profile_skip: "ഒഴിവാക്കുക",
    poll_followup_placeholder: "നിങ്ങളുടെ ചിന്തകൾ മാന്യമായി പങ്കിടൂ…",
    poll_followup_count: (n) => `${n} / 1200 · പ്രസിദ്ധീകരണത്തിന് മുമ്പ് മോഡറേഷൻ നടത്തുന്നു`,
    poll_followup_submit: "എന്റെ പ്രതികരണം പങ്കിടൂ →",
    poll_followup_submitting: "സമർപ്പിക്കുന്നു…",
    poll_followup_min: "ദയവായി കുറച്ച് വാക്കുകളെങ്കിലും എഴുതുക.",
    poll_followup_thanks_title: "നന്ദി.",
    poll_followup_thanks_body: "നിങ്ങളുടെ പ്രതികരണം ലഭിച്ചു, മോഡറേറ്റർമാർ പരിശോധിച്ച ശേഷം പ്രദർശിപ്പിക്കും.",
    poll_share_title: "മറ്റുള്ളവരെയും സംസാരിക്കാൻ ക്ഷണിക്കൂ.",
    poll_share_sub: "കൂടുതൽ ശബ്ദങ്ങൾ പങ്കെടുക്കുന്തോറും കേരളത്തിന്റെ മുൻഗണനകൾ കൂടുതൽ വ്യക്തമാകും.",
    poll_share_whatsapp: "WhatsApp-ൽ ഷെയർ ചെയ്യൂ",
    poll_share_twitter: "X-ൽ ഷെയർ ചെയ്യൂ",
    poll_share_copy: "ലിങ്ക് കോപ്പി ചെയ്യൂ",
    poll_share_copied: "ലിങ്ക് കോപ്പി ചെയ്തു ✓",
    poll_share_native: "ഷെയർ വഴി…",
    poll_share_image_eyebrow: "ഓട്ടോ-ഷെയർ ഇമേജ്",
    poll_share_image_link: "ബ്രാൻഡഡ് ഇമേജ് ഡൗൺലോഡ് ചെയ്യൂ →",
    poll_share_text_mc: "thenextcm.com-ൽ കേരളത്തിലെ തെരുവ് നായ്ക്കളെ കുറിച്ചുള്ള എന്റെ അഭിപ്രായം ഞാൻ പങ്കിട്ടു. കേരളം എന്ത് ചെയ്യണമെന്നാണ് നിങ്ങൾ കരുതുന്നത്?",
    poll_share_text_open: "ഞാൻ കേരളം സംസാരിക്കുന്നു-ൽ എന്റെ ശബ്ദം പങ്കിട്ടു. ചർച്ചയിൽ ചേരൂ:",
    poll_open_cta_title: "ഇത് ഒരു തുറന്ന ചർച്ചയാണ്.",
    poll_open_cta_sub: "നിങ്ങളുടെ സന്ദേശം പങ്കിടാനും മറ്റുള്ളവരെ അപ്‌വോട്ട് ചെയ്യാനും ഹോംപേജിലേക്ക് പോകൂ.",
    poll_open_cta_btn: "കേരളം സംസാരിക്കുന്നു ഹോം തുറക്കൂ →",
    poll_loading: "ലോഡ് ചെയ്യുന്നു…",
    poll_voices_title: "മറ്റ് പൗരന്മാർ പറയുന്നത്",
    poll_voices_sub: (n) => `${n} അംഗീകൃത ശബ്ദ${n === 1 ? "ം" : "ങ്ങൾ"} \u00b7 ഏറ്റവും പുതിയത് ആദ്യം`,
    poll_voices_featured: "\u2605 എഡിറ്റർമാർ തിരഞ്ഞെടുത്തത്",
    poll_not_found: "വോട്ടെടുപ്പ് കണ്ടെത്തിയില്ല.",
    poll_back_home: "← ഹോമിലേക്ക് മടങ്ങൂ",
    poll_load_error: "വോട്ടെടുപ്പ് ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല.",

    // Hero slider (multi-poll)
    hero_live_poll: "തത്സമയ പൗര വോട്ടെടുപ്പ്",
    hero_open_conv: "തുറന്ന ചർച്ച",
    hero_cta_mc: "നിങ്ങളുടെ വോട്ട് രേഖപ്പെടുത്തൂ →",
    hero_cta_open: "നിങ്ങളുടെ ശബ്ദം പങ്കിടൂ →",
  },
};

// Candidate names by language. Initials stay Latin (KV/VS/RC) — universal abbreviations.
export const CANDIDATE_NAMES = {
  en: {
    "kc-venugopal": "K.C. Venugopal",
    "vd-satheesan": "V.D. Satheesan",
    "ramesh-chennithala": "Ramesh Chennithala",
  },
  ml: {
    "kc-venugopal": "കെ.സി. വേണുഗോപാൽ",
    "vd-satheesan": "വി.ഡി. സതീശൻ",
    "ramesh-chennithala": "രമേശ് ചെന്നിത്തല",
  },
};

export function getCandidateName(candidate, lang) {
  return CANDIDATE_NAMES[lang]?.[candidate.id] || candidate.name;
}

// Font stacks used by the canvas (browser falls back automatically in DOM,
// but canvas needs a single resolved font string).
export const CANVAS_FONTS = {
  en: {
    display: "Anton, 'Work Sans', sans-serif",
    body: "'Work Sans', sans-serif",
  },
  ml: {
    display: "'Baloo Chettan 2', 'Noto Sans Malayalam', sans-serif",
    body: "'Noto Sans Malayalam', 'Work Sans', sans-serif",
  },
};
